import React, {useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import ApplicationRoutes from "./routes/route";
import { Header } from "./ui/layout/header/Header";
import Sidebar from "./ui/layout/header/SideBar";
import i18n from "./lib/i18n";
import { GetMe } from "./lib/data";

export default function AppContent() {

    const location = useLocation();
    const isLoginPage = location.pathname === "/login";

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleResize = () => {
        if (window.innerWidth < 968) { 
            setIsSidebarOpen(false);
        }
    };

    useEffect(() => {
        if(!isLoginPage){
            handleGetMe();
        }
    }, [isLoginPage]);

    const handleGetMe = async () => {
        const result = await GetMe();
        if(result){
            localStorage.setItem("username", result?.data.name);
            localStorage.setItem("role_name", result?.data.role);
            localStorage.setItem("permissions", JSON.stringify(result.data.permissions.map((e) => e.name)));
        };
    };

    useEffect(() => {
        document.documentElement.dir = (i18n.language === "en") || (i18n.language === "en-US") ? "ltr" : "rtl";
        if(localStorage.getItem("i18nextLng") === "en-US"){
            localStorage.setItem("i18nextLng", "en");
        };
    }, [i18n.language]);

    useEffect(() => {
       
        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {  
        const contentElement = document.querySelector('.content');  
        if (isSidebarOpen && !isLoginPage) {  
            i18n.language === "ar" ? contentElement.style.paddingRight = '270px' : contentElement.style.paddingLeft = '270px';  
        } 
        else if(!isSidebarOpen && !isLoginPage) {  
            i18n.language === "ar" ? contentElement.style.paddingRight = '80px' : contentElement.style.paddingLeft = '80px';  
        }  
        else {  
            i18n.language === "ar" ? contentElement.style.paddingRight = '0px' : contentElement.style.paddingLeft = '0px';  
        }  
    }, [isSidebarOpen, location.pathname]);

    return (<>
        {!isLoginPage && <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} /> }
        <div className="content bg-primary min-h-screen w-[100%] relative" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
            {!isLoginPage && <Header /> }
            <ApplicationRoutes />
        </div>
    </>)

};